import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer
      id="footer"
      className="relative bg-black bg-[radial-gradient(ellipse_at_center,_rgba(20,229,182,0.05)_0%,_transparent_50%)] py-12 px-6 lg:px-24 z-10 overflow-hidden"
      aria-label="Pie de página"
    >
      {/* Efectos de fondo - puntos y partículas */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#1e293b_1px,transparent_1px),linear-gradient(to_bottom,#1e293b_1px,transparent_1px)] bg-[size:20px_20px] opacity-20"></div>
      <div className="absolute top-10 left-10 w-2 h-2 bg-[#1de9b6] rounded-full animate-pulse"></div>
      <div className="absolute top-20 right-20 w-1 h-1 bg-[#1de9b6] rounded-full animate-pulse delay-700"></div>
      <div className="absolute bottom-10 left-1/4 w-1.5 h-1.5 bg-[#1de9b6] rounded-full animate-pulse delay-1000"></div>

      {/* Desktop Layout */}
      <div className="hidden md:flex flex-col md:flex-row justify-between items-center gap-8 relative z-10">
        
        {/* Logo con efecto mejorado */}
        <div className="flex items-center gap-3 group">
          <div className="relative">
            <img 
              src="/Logo.svg" 
              alt="Logo pequeño de Zennith" 
              className="h-10 w-10 transition-transform duration-300 group-hover:scale-110" 
            />
            <div className="absolute inset-0 bg-[#1de9b6] opacity-0 group-hover:opacity-10 rounded-full transition-opacity duration-300"></div>
          </div>
          <span className="text-[#1de9b6] font-bold text-2xl tracking-wide group-hover:text-[#00E5CC] transition-colors duration-300">
            ZENNITH
          </span>
        </div>

        {/* Íconos sociales con mejor diseño */}
        <div className="flex items-center gap-8">
          
          {/* Email */}
          <a
            href="mailto:contacto@zennith.cl"
            aria-label="Email"
            className="group relative p-3 rounded-full border border-gray-700 hover:border-[#1de9b6] transition-all duration-300 hover:shadow-[0_0_20px_rgba(29,233,182,0.3)]"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="w-5 h-5 text-gray-400 group-hover:text-[#1de9b6] transition-colors duration-300" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              viewBox="0 0 24 24"
            >
              <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
              <rect x="2" y="4" width="20" height="16" rx="2" />
            </svg>
          </a>

          {/* Instagram */}
          <a
            href="https://instagram.com/zennith_cl"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="group relative p-3 rounded-full border border-gray-700 hover:border-[#1de9b6] transition-all duration-300 hover:shadow-[0_0_20px_rgba(29,233,182,0.3)]"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="w-5 h-5 text-gray-400 group-hover:text-[#1de9b6] transition-colors duration-300" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              viewBox="0 0 24 24"
            >
              <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
            </svg>
          </a>

          {/* LinkedIn */}
          <a
            href="https://www.linkedin.com/company/zennith-chile"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="group relative p-3 rounded-full border border-gray-700 hover:border-[#1de9b6] transition-all duration-300 hover:shadow-[0_0_20px_rgba(29,233,182,0.3)]"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="w-5 h-5 text-gray-400 group-hover:text-[#1de9b6] transition-colors duration-300" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              viewBox="0 0 24 24"
            >
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
              <rect width="4" height="12" x="2" y="9" />
              <circle cx="4" cy="4" r="2" />
            </svg>
          </a>
        </div>

        {/* Texto final con efecto */}
        <div className="text-right">
          <p className="text-sm text-gray-400 hover:text-gray-300 transition-colors duration-300">
            {t("footer")}
          </p>
          <div className="mt-2 h-px bg-gradient-to-r from-transparent via-[#1de9b6] to-transparent opacity-30"></div>
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="md:hidden text-center flex flex-col items-center gap-8 relative z-10">
        
        {/* Logo móvil */}
        <div className="flex items-center gap-3 group">
          <div className="relative">
            <img 
              src="/Logo.svg" 
              alt="Logo pequeño de Zennith" 
              className="h-12 w-12 transition-transform duration-300 group-hover:scale-110" 
            />
            <div className="absolute inset-0 bg-[#1de9b6] opacity-0 group-hover:opacity-10 rounded-full transition-opacity duration-300"></div>
          </div>
          <span className="text-[#1de9b6] font-bold text-2xl tracking-wide">
            ZENNITH
          </span>
        </div>

        {/* Íconos sociales móvil */}
        <div className="flex justify-center gap-6">
          
          <a 
            href="mailto:contacto@zennith.cl" 
            aria-label="Email" 
            className="group relative p-4 rounded-full border border-gray-700 hover:border-[#1de9b6] transition-all duration-300 hover:shadow-[0_0_20px_rgba(29,233,182,0.3)]"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="w-6 h-6 text-gray-400 group-hover:text-[#1de9b6] transition-colors duration-300" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              viewBox="0 0 24 24"
            >
              <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
              <rect x="2" y="4" width="20" height="16" rx="2" />
            </svg>
          </a>

          <a 
            href="https://instagram.com/zennith_cl" 
            target="_blank" 
            rel="noopener noreferrer" 
            aria-label="Instagram" 
            className="group relative p-4 rounded-full border border-gray-700 hover:border-[#1de9b6] transition-all duration-300 hover:shadow-[0_0_20px_rgba(29,233,182,0.3)]"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="w-6 h-6 text-gray-400 group-hover:text-[#1de9b6] transition-colors duration-300" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              viewBox="0 0 24 24"
            >
              <rect width="20" height="20" x="2" y="2" rx="5" ry="5" />
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
            </svg>
          </a>

          <a 
            href="https://www.linkedin.com/company/zennith-chile" 
            target="_blank" 
            rel="noopener noreferrer" 
            aria-label="LinkedIn" 
            className="group relative p-4 rounded-full border border-gray-700 hover:border-[#1de9b6] transition-all duration-300 hover:shadow-[0_0_20px_rgba(29,233,182,0.3)]"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="w-6 h-6 text-gray-400 group-hover:text-[#1de9b6] transition-colors duration-300" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              viewBox="0 0 24 24"
            >
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
              <rect width="4" height="12" x="2" y="9" />
              <circle cx="4" cy="4" r="2" />
            </svg>
          </a>
        </div>

        {/* Texto final móvil */}
        <div className="text-center">
          <p className="text-sm text-gray-400">
            {t("footer")}
          </p>
          <div className="mt-3 h-px bg-gradient-to-r from-transparent via-[#1de9b6] to-transparent opacity-30 mx-8"></div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;